import React, { useEffect, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Container,
  Row,
  Col,
  Image,
  Button,
  Form
} from "react-bootstrap";
import GreyStar from "../../assests/images/grey-star.svg";
import YellowStar from "../../assests/images/full-star.svg";
import YellowHalfStar from "../../assests/images/half-star.svg";
import CloseXIcon from "../../assests/images/close-x.svg";

import {
  HeadingView,
  HeadingTitle,
  HeadingText,
  KidsFoundationForm,
  KidsFoundationFormWrap,
  FormBox,
  FormBoxTitle,
  FormRatingGroup,
  FormRatingStar,
  SubmitForm,
  FormBottomGroup,
  FormBottomGroupWrap,
  FormButtonGroup,
  FormButtonGroupImageWrap,
  FormButtonGroupImage,
  CloseButtonIcon,
  FileUploadButtonGroup,
  UploadImageWrap,
  FileUploadText,
  KidsFoundationFormButton,
  FormTextIcon,
  FormTextIconTwo,
  FileUploadTextSpan,
} from "./submitReviewStyle";
import { FieldArray, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { MESSAGE } from "../../utils/message";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { DropdownOptions } from "../../utils/types";
import FilterDropdown from "../../components/common/filterDropdown/filterDropdown";
import { useDispatch, useSelector } from "react-redux";
import {  addEditReviewHandler } from "../../redux/slices/donationCamp/addEditReview-slice";
import { reviewRolesHandler } from "../../redux/slices/myNonprofit/reviewRole-slice";
import MetaComponent from "../../components/common/metaComponent";
import { retrieveReviewsHandler } from "../../redux/slices/donationCamp/retrieveReviews-slice";
import {  updateReviewHandler } from "../../redux/slices/donationCamp/updateReview-slice";

const SubmitReview = () => {
  const [files, setFiles] = useState<File[]>([]);
  const navigate: any = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = !!localStorage.getItem("token");


  const roles = useSelector((state: any) => state.reviewRoles?.data?.results);
  const retrieveReview = useSelector((state: any) => state.retrieveReview?.data?.results);

  const submitReviewLoading = useSelector((state: any) => state.updateReview?.isLoading);

  const { id } = useParams();
  const { state } = useLocation();

  const reviewId = id ? id : "";

  useEffect(() => {
    state?.editReview && dispatch(retrieveReviewsHandler(state?.editReview) as any)
  }, [state?.editReview])

  useEffect(() => {
    if (isAuthenticated) {
      const pendingReview = localStorage.getItem("pendingReview");
      if (pendingReview) {
        submitReview(JSON.parse(pendingReview), formik.resetForm);
      }
    }
  }, [isAuthenticated]);

  const isEditing = !!state?.editReview;

  const formik: any = useFormik({
    initialValues: {
      role_id: isEditing ? retrieveReview?.review_role || "" :" ",
      rating: isEditing ? retrieveReview?.rating || 0 : 0,
      review: isEditing ? retrieveReview?.review || "": " ",
      images: isEditing ? (retrieveReview?.images || []).filter((img: any) => img && (typeof img === "string" || img instanceof File)):[],
      videos: isEditing  ?retrieveReview?.videos || [] as string[] : [],
    },
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      role_id: Yup.string().trim().required(MESSAGE.requiredErrors("Role")),
      rating: Yup.number()
        .min(1, MESSAGE.requiredErrors("Rating"))
        .required(MESSAGE.requiredErrors("Rating")),
      review: Yup.string()
        .required(MESSAGE.requiredErrors("Your experience with this nonprofit"))
        .min(50, MESSAGE.minLengthErrors("experience", 50))
        .max(1000, MESSAGE.maxDigitErrors("experience", 1000)),
      images: Yup.array().of(Yup.mixed()).max(4, "You can upload up to 4 files only"),

      videos: Yup.array()

        .of(
          Yup.string()
            .url("Please enter a valid URL")
            .nullable() // Allows empty values without validation error
        )
        .max(4, "You can upload up to 4 files only"),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (!isAuthenticated) {
        localStorage.setItem("pendingReview", JSON.stringify(values));
        localStorage.setItem("reviewPath", `/write-review/${id}`);
        navigate("/signin")
        return;
      }
      await submitReview(values, resetForm);
    },
    // onSubmit: async (values: any, { resetForm }: any) => {
    //   const formData = new FormData();

    //   formData.append('role_id', values.role_id);
    //   formData.append('rating', values.rating.toString());
    //   formData.append('review', values.review);

    //   values.images.forEach((image: string | File, index: number) => {
    //     if (typeof image === "string") {
    //       formData.append(`images[${index}]`, image); // URL
    //     } else {
    //       formData.append(`images[${index}]`, image); // File
    //     }
    //   });

    //   if (values.images.length === 0) {
    //     formData.append(`images[]`, values.images);
    //   }

    //   const validVideos = values.videos.filter((video: string) => video && video !== "0");
    //   if (validVideos.length > 0) {
    //     validVideos.forEach((videoUrl: string, index: number) => {
    //       formData.append(`videos[${index}]`, videoUrl);
    //     });
    //   }

    //   if (state?.editReview) {
    //     await dispatch(updateReviewHandler(state?.editReview, formData) as any);

    //     await resetForm({});
    //     typeof localStorage !== "undefined" && localStorage.removeItem("reviewPath")
    //     navigate(`/review/${id}`, { state: { updated: "updated" } });
    //   } else if (id) {
    //     await dispatch(addEditReviewHandler(id, formData) as any).then((res: any) => {
    //       typeof localStorage !== "undefined" && localStorage.removeItem("reviewPath")
    //       if (res?.review_id) {
    //         navigate(`/review/${res?.review_id}`);
    //       }
    //     })

    //     await resetForm({});

    //   }
    // },
  });

  const submitReview = async (values: any, resetForm: any) => {
    const formData = new FormData();
    formData.append("role_id", values.role_id);
    formData.append("rating", values.rating.toString());
    formData.append("review", values.review);

    values.images.forEach((image: string | File, index: number) => {
      if (typeof image === "string") {
        formData.append(`images[${index}]`, image);
      } else {
        formData.append(`images[${index}]`, image);
      }
    });

    values.videos.forEach((videoUrl: string, index: number) => {
      formData.append(`videos[${index}]`, videoUrl);
    });

    if (state?.editReview) {
      await dispatch(updateReviewHandler(state?.editReview, formData) as any);
      
      resetForm();
      localStorage.removeItem("pendingReview");
      navigate(`/review/${id}`, { state: { updated: "updated" } });
    } else {
      if (!reviewId) {
        console.error("Error: ID is missing!");
        return;
      }

      const res = await dispatch(addEditReviewHandler(reviewId as any, formData) as any);
    
      localStorage.removeItem("pendingReview");
      if (res?.review_id) {
        navigate(`/review/${res?.review_id}`);
      }
    }
  };




  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(e.target.files || []);
    let validImages = true
    newFiles.forEach(item => {
      if (!item.type.includes("image")) {
        validImages = false
      }
    })
    if (!validImages) {
      formik.setFieldError("images", "Please upload valid image file");
      return
    }
    // Filter to only keep new files and prevent exceeding the limit
    if (formik.values.images.length + newFiles.length <= 4) {
      const newFileObjects = newFiles.filter(file => file instanceof File);
      // If there are URLs present, we only need to handle new file objects
      const currentFileObjects = formik.values.images.filter((img: any) => img instanceof File);
      const updatedImages = [...currentFileObjects, ...newFileObjects];

      setFiles([...files, ...newFileObjects]);
      formik.setFieldValue("images", updatedImages);
    }
  };


  const handleRemoveFile = (index: number) => {
    const updatedImages = formik.values.images.filter((_: any, i: number) => i !== index);

    // Handle file removal in the local state
    const fileToRemove = formik.values.images[index];
    if (fileToRemove instanceof File) {
      setFiles(files.filter((_file, i) => i !== index));
    }

    formik.setFieldValue("images", updatedImages);
  };



  const options = useMemo<DropdownOptions[]>(() => {
    const tempRoles: DropdownOptions[] = [];
    if (roles?.length) {
      roles.forEach((item: any) =>

        tempRoles.push({ label: item?.title, value: item?.id })

      );
    }
    tempRoles.unshift({ label: "Select Role", value: "" });
    return tempRoles;
  }, [roles]);

  useEffect(() => {
    dispatch(reviewRolesHandler() as any);
  }, []);

  const getStarImage = (rating: number, star: number) => {
    if (rating >= star) {
      return YellowStar;
    } else if (rating >= star - 0.5) {
      return YellowHalfStar;
    } else {
      return GreyStar;
    }
  };

  const totalFilesAndVideos = formik.values.images.length + formik.values.videos.length;
  const remainingSlots = 4 - totalFilesAndVideos;
  const disableAddButtons = totalFilesAndVideos >= 4;

  return (
    <>
      <MetaComponent
        keywords=""
        description="Submit your rating and write a review for Collegiate Swimming Officials Association Inc. Share your experience and help others learn about this Norwood nonprofit organization!"
        ogTitle="Write a Review for Collegiate Swimming Officials Association Inc (Norwood, MA)"
        ogDescription="Submit your rating and write a review for Collegiate Swimming Officials Association Inc. Share your experience and help others learn about this Norwood nonprofit organization!"
        ogUrl="https://qa.greatnonprofits.org/reviews/write/collegiate-swimming-officials-association-inc"
        ogImage="https://cdn.greatnonprofits.org/img/dashboard/gnp_bug-orange.png"
      />
      <>
        <HeadingView>
          <Container className="cont-w">
            <Row>
              <Col sm="12">
                <HeadingTitle>{state?.title}</HeadingTitle>
                <HeadingText>
                  By writing a review you are helping others learn about this
                  nonprofit. The most useful reviews are detailed and candid.
                </HeadingText>
              </Col>
            </Row>
          </Container>
        </HeadingView>

        <KidsFoundationForm>
          <Container className="cont-w">
            <Row>
              <Col sm="12">
                <KidsFoundationFormWrap>
                  <FormikProvider value={formik}>
                    <SubmitForm
                      className="submit-rating-form"
                      onSubmit={formik.handleSubmit}
                    >
                      <FormBox>
                        <FormBoxTitle>Choose Your Role:</FormBoxTitle>
                        <FilterDropdown
                          options={options}
                          selectedFilter={formik.values.role_id}
                          setSelectedFilter={(value) => {
                            formik.setFieldValue("role_id", value)
                          }
                          }
                        />
                        {formik.touched.role_id && formik.errors.role_id && (
                          <div className="error">{formik.errors.role_id}</div>
                        )}
                      </FormBox>

                      <FormBox>
                        <FormBoxTitle>Rate this nonprofit:</FormBoxTitle>
                        <FormRatingGroup>
                          {[1, 2, 3, 4, 5].map((star, index) => (
                            <FormRatingStar
                              key={index + 1}
                              onClick={() => formik.setFieldValue("rating", star)}
                            >
                              <Image
                                src={getStarImage(formik.values.rating, star)}
                                alt="Star"
                              />
                            </FormRatingStar>
                          ))}
                        </FormRatingGroup>
                        &nbsp;
                        {formik.values.rating === 0 && <p>(Click to Rate)</p>}
                        {formik.values.rating === 1 && (
                          <p>(For Below expectations)</p>
                        )}
                        {formik.values.rating === 2 && (
                          <p>(Below expectations)</p>
                        )}
                        {formik.values.rating === 3 && (
                          <p>(Meets expectations)</p>
                        )}
                        {formik.values.rating === 4 && (
                          <p>(Exceeds expectations)</p>
                        )}
                        {formik.values.rating === 5 && (
                          <p>(Far Exceeds expectations)</p>
                        )}
                        <div className="rating-review-error">
                          {formik.touched.rating && formik.errors.rating && (
                            <div className="error">{formik.errors.rating}</div>
                          )}
                        </div>
                      </FormBox>

                      <FormBottomGroup>
                        <FormBoxTitle>
                          Tell us your experience with this nonprofit
                        </FormBoxTitle>
                        <FormBottomGroupWrap>
                          <Form.Group
                            className="mb-3 form-rating-textarea"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Control
                              as="textarea"
                              rows={3}
                              maxLength={1000}
                              placeholder="Tell your story & help a charity get noticed!"
                              value={formik.values.review}
                              onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= 1000) {
                                  formik.setFieldValue('review', inputValue);
                                }
                              }}
                              onBlur={formik.handleBlur}
                              name="review"
                            />
                          </Form.Group>
                          {formik.touched.review && formik.errors.review && (
                            <div className="error">{formik.errors.review}</div>
                          )}

                          <FormButtonGroup>
                            <FormButtonGroupImageWrap>
                              <UploadImageWrap className="image-show">
                                <FormButtonGroupImage>
                                  {formik.values.images.map((image: any, index: any) => (
                                    <FormButtonGroupImage key={index + 1}>
                                      {typeof image === "string" ? (
                                        <Image src={image} alt={`Upload ${index + 1}`} />
                                      ) : (
                                        <Image src={URL.createObjectURL(image)} alt={`Upload ${index + 1}`} />
                                      )}
                                      <CloseButtonIcon
                                        onClick={() => handleRemoveFile(index)}
                                      >
                                        <Image
                                          src={CloseXIcon}
                                          alt="Close X Icon"
                                        />
                                      </CloseButtonIcon>
                                    </FormButtonGroupImage>
                                  ))}

                                </FormButtonGroupImage>
                              </UploadImageWrap>

                              <FileUploadButtonGroup>
                                <Form.Group
                                  className="add-image-button"
                                  controlId="formFileLg1"
                                >
                                  <Form.Label>
                                    <FormTextIcon>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16.159 16"
                                      >
                                        <g
                                          id="add"
                                          transform="translate(-2.587 -30.496)"
                                        >
                                          <path
                                            id="Path_41286"
                                            data-name="Path 41286"
                                            d="M18.747,38.495a1.336,1.336,0,0,1-1.336,1.336H12.025v5.387a1.336,1.336,0,0,1-2.67,0V39.831H3.965a1.336,1.336,0,1,1,0-2.671H9.353V31.773a1.336,1.336,0,0,1,2.67,0V37.16h5.388A1.336,1.336,0,0,1,18.747,38.5Z"
                                            transform="translate(0)"
                                          />
                                        </g>
                                      </svg>
                                    </FormTextIcon>
                                    Add Photo
                                  </Form.Label>
                                  <Form.Control
                                    type="file"
                                    size="lg"
                                    accept=".jpg, .jpeg, .png, .gif, .webp, .psd, .eps, .svg"
                                    multiple
                                    disabled={disableAddButtons}
                                    onChange={handleFileUpload}
                                  />
                                </Form.Group>

                                <Form.Group>
                                  <Form.Label
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (!disableAddButtons) {
                                        formik.setFieldValue("videos", [
                                          ...formik.values.videos,
                                          "",
                                        ]);
                                      }
                                    }}
                                    disabled={disableAddButtons}
                                    className="add-image-button add-video-button"
                                  >
                                    <FormTextIconTwo>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16.159 16"
                                      >
                                        <g
                                          id="add"
                                          transform="translate(-2.587 -30.496)"
                                        >
                                          <path
                                            id="Path_41286"
                                            data-name="Path 41286"
                                            d="M18.747,38.495a1.336,1.336,0,0,1-1.336,1.336H12.025v5.387a1.336,1.336,0,0,1-2.67,0V39.831H3.965a1.336,1.336,0,1,1,0-2.671H9.353V31.773a1.336,1.336,0,0,1,2.67,0V37.16h5.388A1.336,1.336,0,0,1,18.747,38.5Z"
                                            transform="translate(0)"
                                            fill="#333333"
                                          />
                                        </g>
                                      </svg>
                                    </FormTextIconTwo>
                                    Add Video
                                  </Form.Label>
                                </Form.Group>

                                <FileUploadText>
                                  Add up to 4 files{" "}
                                  <FileUploadTextSpan>
                                    ({remainingSlots} Remaining)
                                  </FileUploadTextSpan>
                                </FileUploadText>
                              </FileUploadButtonGroup>
                              <FieldArray
                                name="videos"
                                render={({ remove }) => {
                                  return formik.values.videos?.map(
                                    (_: any, i: number) => (
                                      <React.Fragment key={i}>
                                        <Col md={10}>
                                          <Form.Control
                                            type="text"
                                            name={`videos[${i}]`}
                                            placeholder="Enter Video URL"
                                            value={formik.values.videos[i]}
                                            onChange={formik.handleChange}
                                          />
                                        </Col>
                                        <Col md={2}>
                                          <Button
                                            className="image-close-btn"
                                            onClick={() => remove(i)}
                                          >
                                            X
                                          </Button>
                                        </Col>
                                      </React.Fragment>
                                    )
                                  );
                                }}
                              />

                            </FormButtonGroupImageWrap>
                          </FormButtonGroup>
                          {formik.errors.videos && (
                            <div className="error">{formik.errors.videos}</div>
                          )}
                        </FormBottomGroupWrap>
                      </FormBottomGroup>

                      <KidsFoundationFormButton>
                        <Button
                          className="btn-outline-success-blue"
                          type="submit"
                          disabled={submitReviewLoading}
                        >
                          Post Review
                          {submitReviewLoading && <span className="btnloader"></span>}
                        </Button>
                      </KidsFoundationFormButton>
                    </SubmitForm>
                  </FormikProvider>
                </KidsFoundationFormWrap>
              </Col>
            </Row>
          </Container>
        </KidsFoundationForm>
      </>
    </>

  );
};
export default SubmitReview;
